import { useTranslation } from 'react-i18next'

import { Divider } from '@reveni-io/reveni-ui'

import { getRefundMethodFieldId } from '@/configuration/pages/ConfigurationPage/RefundsConfiguration/helpers'
import { providers } from '@/returns/constants'

import ExtraAmountSelector from '../ExtraAmountSelector/ExtraAmountSelector'
import ExtraCreditAccumulationToggle from '../ExtraCreditAccumulationToggle/ExtraCreditAccumulationToggle'
import InputAndSelect from '../InputAndSelect/InputAndSelect'
import CombineDiscountsSelector from './CombineDiscountsSelector/CombineDiscountsSelector'
import { storeCreditsDurationTypes } from './constants'
import * as Styles from './styles'

const StoreCreditConfiguration = ({
  extraValueType,
  handleExtraValueType,
  extraValue,
  handleExtraValue,
  maxExtraAmount,
  handleMaxExtraAmount,
  minEligibleRefundAmount,
  handleMinEligibleRefundAmount,
  storeCurrencySymbol,
  errors,
  refundMethodName,
  duration,
  onChangeInputDuration,
  onChangeSelectDuration,
  provider,
  discountCombinations,
  onChangeDiscountCombinations,
  allowExtraWhenPaidWithCredit,
  handleAllowExtraWhenPaidWithCredit,
  disabled,
}) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <InputAndSelect
        label={t('Validez')}
        menuItems={[
          { label: t('Años'), value: storeCreditsDurationTypes.years },
          { label: t('Meses'), value: storeCreditsDurationTypes.months },
          { label: t('Días'), value: storeCreditsDurationTypes.days },
        ]}
        inputValue={duration?.number}
        inputOnChange={onChangeInputDuration}
        inputError={Boolean(errors?.duration)}
        inputFieldId={getRefundMethodFieldId(refundMethodName, 'duration')}
        selectValue={duration?.type}
        selectOnChange={onChangeSelectDuration}
        showToggleExpirationSelect={false}
        disabled={disabled}
      />
      <Divider />
      <ExtraAmountSelector
        value={extraValueType}
        onChange={handleExtraValueType}
        extraValue={extraValue}
        handleExtraValue={handleExtraValue}
        maxExtraAmount={maxExtraAmount}
        handleMaxExtraAmount={handleMaxExtraAmount}
        minEligibleRefundAmount={minEligibleRefundAmount}
        handleMinEligibleRefundAmount={handleMinEligibleRefundAmount}
        storeCurrencySymbol={storeCurrencySymbol}
        disabled={disabled}
        errors={errors}
        refundMethodName={refundMethodName}
      />
      <ExtraCreditAccumulationToggle
        checked={allowExtraWhenPaidWithCredit}
        onChange={handleAllowExtraWhenPaidWithCredit}
        disabled={disabled}
        label={t('Añadir crédito adicional aunque el pedido haya sido pagado con crédito en tienda.')}
      />
      {provider === providers.shopify && (
        <>
          <Divider />
          <CombineDiscountsSelector
            discounts={discountCombinations}
            onChange={onChangeDiscountCombinations}
            disabled={disabled}
          />
        </>
      )}
    </Styles.Container>
  )
}

export default StoreCreditConfiguration
